const impersonationEvents = {
    Transitioning: {
        Name: "IMPERSONATION.TRANSITIONING",
        New(transitionTypeName) {
            return {
                type: impersonationEvents.Transitioning.Name,
                TransitionTypeName: transitionTypeName
            };
        }
    },
    Transitioned: {
        Name: "IMPERSONATION.TRANSITIONED",
        New(transitionTypeName) {
            return {
                type: impersonationEvents.Transitioned.Name,
                TransitionTypeName: transitionTypeName
            };
        }
    },
    TransitionErrored: {
        Name: "IMPERSONATION.TRANSITIONERRORED",
        New(transitionTypeName, ex) {
            return {
                type: impersonationEvents.TransitionErrored.Name,
                TransitionTypeName: transitionTypeName,
                Error: ex
            };
        }
    }
};

module.exports = impersonationEvents;


// WEBPACK FOOTER //
// ./src/events/impersonation/impersonationEvents.js